import { render, staticRenderFns } from "./EditDocumentType.vue?vue&type=template&id=54d7db99&"
import script from "./EditDocumentType.vue?vue&type=script&lang=js&"
export * from "./EditDocumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports